import { useEffect, useState } from 'react';
// import './SubModal.css';
import * as Yup from 'yup';
import Form from '../../../components/form/components/Form/Form';
import FormField from '../../../components/form/components/FormField/FormField';
import Button from '../../../components/form/components/Button/Button';
import ErrorMessage from '../../../components/form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs,setDoc, addDoc, getDoc, updateDoc, serverTimestamp, arrayUnion   } from "firebase/firestore"; 

import { Timestamp } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

// const initialValues= {
//   plan_name: null,
//   plan_name_fr: null,
//   price_1m:  null,
//   price_3m:  null,
//   price_6m:  null,
//   price_12m:  null,
// }

const override = {
    marginTop: '20px'
  };


function EditPlansModal({ onClose, onContentUpdated, item, activeCaseData } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    const [user] = useAuthState(auth);
    const [gender, setGender] = useState('');


    const [initialValues, setInitialValues] = useState({
        name: item?.name,
        name_french: item?.name_french,
        price_1m:  item?.price_1m,
        price_3m:  item?.price_3m,
        price_6m:  item?.price_6m,
        price_12m:  item?.price_12m,
    })

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Phone is required'),
        name_french: Yup.string().required('Phone is required'),
        price_1m: Yup.number().required("Price Is Required"),
        price_3m: Yup.number().required("Price Is Required"),
        price_6m: Yup.number().required("Price Is Required"),
        price_12m: Yup.number().required("Price Is Required"),
    })

    let [description, setDescription ] = useState('');
    let [descriptionFr, setDescriptionFr ] = useState('');

    // NEW VALS

    const handleSubmitData = async (values: any) => {
            // console.log('VALS:  ',  values);

            try {
              
            // console.log('VALUES: ',{
            //   ...values,
            //   price_1m:  Number(values?.price_1m),
            //   price_3m: Number(values?.price_3m),
            //   price_6m: Number(values?.price_6m),
            //   price_12m: Number(values?.price_12m),
            //   description: description,
            //   descriptionFr: descriptionFr
            // });
            setLoading(true);
            let reqData = {
              ...values,
              price_1m:  Number(values?.price_1m),
              price_3m: Number(values?.price_3m),
              price_6m: Number(values?.price_6m),
              price_12m: Number(values?.price_12m),
              description: description,
              description_french: descriptionFr
            };

            const plansRef = doc(collection(db, "Plans"), item.id);

            await updateDoc(plansRef, reqData);

            setLoading(false);
            onContentUpdated();
            
            toast.success("Plan Updated successfully", {
              pauseOnHover: false,
              closeOnClick: true,
            });

            } catch (error) {
              setLoading(false);

              toast.error("Error Creating Error", {
                pauseOnHover: false,
                closeOnClick: true,
              });
            }
    }

    useEffect(() => {
        //Set Desc
        // console.log('DATA: ', item);

        if(item?.description) {
            setDescription(item?.description);
        }
        if(item?.description_french) {
            setDescriptionFr(item?.description_french)
        }
    },[item])



    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="plans-modal">
                <div className='modal-head'>
                    <p className="modal-title">Plan Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitData}
                    validationSchema={validationSchema}
                >
    
                <p className="label-text">Plan's Name: </p>
                  <FormField  name="name" type="text" placeholder="Enter Plan's Name"/>
                <br />
                <p className="label-text">Plan's Name French: </p>
                  <FormField  name="name_french" type="text" placeholder="Enter Plan's Name"/>
                <br />
                <p className="label-text">Description: </p>
                <textarea rows={4} onChange={(e: any) => setDescription(e.target.value)} value={description} className="textarea"></textarea>
                <br />
                <br />
                <p className="label-text">Description French: </p>
                <textarea rows={4} onChange={(e: any) => setDescriptionFr(e.target.value)} value={descriptionFr} className="textarea"></textarea>
                <br />
                <br />
                <p className="label-text">Price 1M: </p>
                  <FormField name="price_1m" type="number" placeholder="Subscription Length" />
                <br />
                <p className="label-text">Price 3M: </p>
                  <FormField name="price_3m" type="number" placeholder="Subscription Length" />
                <br />
                <p className="label-text">Price 6M: </p>
                  <FormField name="price_6m" type="number" placeholder="Subscription Length" />
                <br />
                <p className="label-text">Price 12M: </p>
                  <FormField name="price_12m" type="number" placeholder="Subscription Length" />
                <br />
             
                <br />
                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT DATA"/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default EditPlansModal;



